import type {ProductListInterface} from "~~/server/types/Products";

export function useFavorites() {
    const favoritesStore = useFavoritesStore();
    const adding=ref<Record<string, boolean>>({});


    const addToFavorites = async (product:ProductListInterface|undefined) => {
        if (!product) {
            throw new Error('Invalid product');
        }
        try {
            adding.value[product.id]=true;
            await favoritesStore.add(product);
        }
        finally {
            adding.value[product.id]=false;
        }
    };

    const removeFromFavorites = async (product:ProductListInterface|undefined) => {
        if (!product) {
            throw new Error('Invalid product');
        }
        try {
            adding.value[product.id]=true;
            await favoritesStore.remove(product.id);
        }
        finally {
            adding.value[product.id]=false;
        }
    };

    const in_favorites=(id:number|undefined)=>favoritesStore.favorites.some(f=>f.product_id===id);


    return { in_favorites,addToFavorites, removeFromFavorites: removeFromFavorites,adding };
}
